/* ==========================================================================
   MEE BARSA - DRAFT 4.  Two small behaviours, both added from OUTSIDE the
   files they affect so each reverts by deleting one <script> tag in
   sections/mb-footer.liquid.

     1. Price on the wishlist cards        (Anjali, 28 Aug 21:51)
     2. The search field takes focus when the search opens
   ========================================================================== */
(function () {
  if (window.__mbDraft4) return;
  window.__mbDraft4 = true;

  /* ------------------------------------------------------------------------
     1.  PRICE ON THE WISHLIST CARDS.
     Anjali: "when we add items to wish list, could we also have the price if
     the item. It's easy for Cx to compare."

     WHY NOT AN EDIT TO component-wishlist.js: that file is 10KB of load-bearing
     logic (localStorage, pruning of deleted handles, the mini preview, the
     header heart) and the only change wanted is one line of markup per card.
     Adding it from outside keeps that file byte-identical to draft 3.

     HOW: the grid is rendered with innerHTML and RE-RENDERED on every
     mb:wishlist:change, so a one-shot pass would be wiped the first time she
     removes a piece. A MutationObserver re-decorates after every render.

     The product JSON is fetched again by handle - the browser serves it from
     its own HTTP cache - and each promise is memoised, so a card that
     re-renders five times still only asks once.

     ⚠ PRICE 0 IS NOT FREE. Pricing is Anjali's to do, and pieces sit at zero
     until she does. "₹0" on a wishlist would read as a bug or a giveaway, so
     those show "price on request" - the same language the product page uses
     for its Enquire path. This is a finished state, not a placeholder.
     ---------------------------------------------------------------------- */
  var cache = {};

  function money(paise) {
    var n = paise / 100;
    var frac = (n % 1) ? 2 : 0;
    try {
      return '₹' + n.toLocaleString('en-IN', {
        minimumFractionDigits: frac,
        maximumFractionDigits: frac
      });
    } catch (e) {
      return '₹' + n.toFixed(frac);
    }
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function priceLine(product) {
    var el = document.createElement('span');
    el.className = 'mb-wl-price';
    var value = (product.price_varies && product.price_min != null) ? product.price_min : product.price;
    if (!value || value <= 0) {
      el.className += ' is-request';
      el.textContent = 'price on request';
    } else {
      el.textContent = (product.price_varies ? 'From ' : '') + money(value);
    }
    return el;
  }

  function decorate(card) {
    if (!card || card.querySelector('.mb-wl-price')) return;
    var handle = card.getAttribute('data-wl-handle');
    if (!handle) return;
    card.setAttribute('data-mb-price', 'pending');
    fetchProduct(handle).then(function (product) {
      if (!product) { card.removeAttribute('data-mb-price'); return; }
      var name = card.querySelector('.mb-cname');
      if (!name || !name.parentNode || card.querySelector('.mb-wl-price')) return;
      name.parentNode.insertBefore(priceLine(product), name.nextSibling);
      card.setAttribute('data-mb-price', 'done');
    });
  }

  function sweepWishlist(grid) {
    grid.querySelectorAll('.mb-wl-card').forEach(decorate);
  }

  function startWishlist() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    sweepWishlist(grid);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () { sweepWishlist(grid); })
      .observe(grid, { childList: true });
  }

  /* ------------------------------------------------------------------------
     2.  THE SEARCH FIELD TAKES FOCUS WHEN THE SEARCH OPENS.

     snippets/mb-search.liquid reveals the field on a click of
     .mb-search-toggle but never focuses it, so opening search and typing did
     nothing - the keystrokes went to the page. Every storefront search this
     is modelled on focuses on open; leaving it unfocused is the kind of thing
     a customer reads as "the search is broken".

     Bound by DELEGATION on document, because the toggle exists in five
     separate headers (homepage, collection, product/cart via mb-store-header,
     search, wishlist) and this file loads once for all of them.

     Two frames of delay, not a timeout: the field is revealed by a class
     change, and an element cannot take focus while it is still display:none
     or visibility:hidden. Two rAFs put the focus call after the style and
     layout have both settled, and match how the hero arms its film.

     preventScroll keeps a phone from jumping the page to the header.
     ---------------------------------------------------------------------- */
  function focusSearch(scope) {
    var field = scope.querySelector('input[type="search"], input[name="q"]');
    if (!field) return;
    if (field.offsetParent === null) return;
    try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
    if (field.value) field.select();
  }

  function startSearchFocus() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.mb-search-toggle, [data-mb-search-toggle]');
      if (!toggle) return;
      var scope = toggle.closest('.mb-search, .mb-srch, header, .mb-open-chrome') || document;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { focusSearch(scope); });
      });
    }, true);
  }

  function start() {
    startWishlist();
    startSearchFocus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();